// Flow Runtime settings
window.manywho = {
    adminTenantId: document.querySelector('meta[name="admin-tenant-id"]').getAttribute('content'),
    cdnUrl: document.querySelector('meta[name="runtime-asset-url"]').getAttribute('content'),
    platformUri: '',
    runtimeUri: document.querySelector('meta[name="runtime-uri"]').getAttribute('content'),
    requires: ['core', 'bootstrap3'],
    customResources: [
        // Flow admin JS is loaded here because it has dependencies loaded by the runtime
        // Loading here insures it gets loaded after all runtime assets have finished downloading
        `${document.querySelector('meta[name="admin-asset-url"]').getAttribute('content')}/flow-admin.js`
    ],
    initialize: function () {}
};

 // Set the base path for mxgraph to find assets
 window.mxBasePath = `${document.querySelector('meta[name="admin-asset-url"]').getAttribute('content')}/lib/mxgraph/src`;

// Pendo snippet
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
    v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('c9f17b5c-49a2-42df-49dd-bae3a8931eab');